import GenericSelector from '../../../../../../../components/global/GenericSelector/GenericSelector';
import React, { useCallback } from 'react';
import { useAppDispatch } from '../../../../../../../store';
import { PayloadAction } from '@reduxjs/toolkit';

interface RedistributionGenericSelectorFilterOptionsProps {
  label: string;
  options: { id: number; label: string }[];
  value: number | undefined;
  dispatcher: (value: number | undefined) => PayloadAction<number | undefined>;
  loading?: boolean;
}

/**
 * Generic selector to be used as redistribution filter.
 * Dispatches selected value to the store.
 * @param label Label of the selector
 * @param options options to use
 * @param value currently selected value or undefined
 * @param dispatcher
 */
const RedistributionGenericSelectorFilter: React.FC<
  RedistributionGenericSelectorFilterOptionsProps
> = ({ label, options, value, dispatcher, loading }) => {
  const dispatch = useAppDispatch();

  const onItemSelected = useCallback(
    (itemId: number) => {
      dispatch(dispatcher(itemId));
    },
    [dispatch, dispatcher],
  );

  return (
    <GenericSelector
      options={options}
      label={label}
      value={value}
      onChange={onItemSelected}
      loading={loading}
      showSearch
    />
  );
};

export default RedistributionGenericSelectorFilter;
